<template>
  <section class="px-10 pb-10 mx-auto mt-8 sm-max:px-5 max-w-screen-2xl">
    <div class="grid grid-cols-12">
      <div class="col-span-4 mt-20 sm-max:col-span-12 md-max:mt-4">
        <nuxt-img
            class="w-full m-auto"
            width="416"
            height="703"
            loading="lazy"
            :alt="imageOneAlt"
            format="webp"
            sizes="sm:440px md:100vw lg:100vw xl:703px"
            :src="imageOneSrc"
        ></nuxt-img>
      </div>
      <div class="col-span-8 sm-max:col-span-12">
        <nuxt-img
            class="w-full m-auto"
            width="728"
            height="780"
            loading="lazy"
            :alt="imageTwoAlt"
            format="webp"
            sizes="sm:440px md:100vw lg:100vw xl:728px"
            :src="imageTwoSrc"
        ></nuxt-img>
      </div>
    </div>
    <div>
      <nuxt-img
          class="w-full m-auto"
          width="1040"
          height="686"
          loading="lazy"
          :alt="imageThreeAlt"
          format="webp"
          sizes="sm:440px md:100vw lg:100vw xl:1040px"
          :src="imageThreeSrc"
      ></nuxt-img>
    </div>
    <div class="grid grid-cols-2">
      <div class="col-span-1 sm-max:col-span-2 sm:border-r-4 border-gray">
        <nuxt-img
            class="w-full m-auto"
            width="520"
            height="3650"
            loading="lazy"
            :alt="imageFourAlt"
            format="webp"
            sizes="sm:440px md:100vw lg:100vw xl:520px"
            :src="imageFourSrc"
        ></nuxt-img>
      </div>
      <div class="col-md-1 md-max:col-span-2">
        <nuxt-img
            class="w-full m-auto"
            width="520"
            height="2532"
            loading="lazy"
            :alt="imageFiveAlt"
            format="webp"
            sizes="sm:440px md:100vw lg:100vw xl:520px"
            :src="imageFiveSrc"
        ></nuxt-img>
      </div>
    </div>
    <div class="grid grid-cols-3">
      <div class="col-span-1 sm-max:col-span-3">
        <nuxt-img
            class="w-full m-auto"
            width="347"
            height="285"
            loading="lazy"
            :alt="imageSixAlt"
            format="webp"
            sizes="sm:440px md:100vw lg:100vw xl:347px"
            :src="imageSixSrc"
        ></nuxt-img>
      </div>
      <div class="col-span-1 sm-max:col-span-3">
        <nuxt-img
            class="w-full m-auto"
            width="347"
            height="285"
            loading="lazy"
            :alt="imageSevenAlt"
            format="webp"
            sizes="sm:440px md:100vw lg:100vw xl:347px"
            :src="imageSevenSrc"
        ></nuxt-img>
      </div>
      <div class="col-span-1 sm-max:col-span-3">
        <nuxt-img
            class="w-full m-auto"
            width="347"
            height="285"
            loading="lazy"
            :alt="imageEightAlt"
            format="webp"
            sizes="sm:440px md:100vw lg:100vw xl:347px"
            :src="imageEightSrc"
        ></nuxt-img>
      </div>
    </div>
  </section>
</template>
<script setup>


defineProps({
  imageOneSrc: {
    type: String,
    default: '/assets/images/everyone.png'
  },
  imageOneAlt: {
    type: String,
    default: 'lifeboost coffee including'
  },
  imageTwoSrc: {
    type: String,
    default: '/assets/images/charts.jpg'
  },
  imageTwoAlt: {
    type: String,
    default: 'top-influencers'
  },
  imageThreeSrc: {
    type: String,
    default: '/assets/images/fb-results.jpg'
  },
  imageThreeAlt: {
    type: String,
    default: 'lifeboost charts'
  },
  imageFourSrc: {
    type: String,
    default: '/assets/images/testimonials_01.jpg'
  },
  imageFourAlt: {
    type: String,
    default: 'doctors love lifeboost'
  },
  imageFiveSrc: {
    type: String,
    default: '/assets/images/testimonials_02.jpg'
  },
  imageFiveAlt: {
    type: String,
    default: 'health fitness professionals love lifeboost'
  },
  imageSixSrc: {
    type: String,
    default: '/assets/images/dan-long.jpg'
  },
  imageSixAlt: {
    type: String,
    default: 'Dan Long'
  },
  imageSevenSrc: {
    type: String,
    default: '/assets/images/ed.jpg'
  },
  imageSevenAlt: {
    type: String,
    default: 'Ed o\'Keefe'
  },
  imageEightSrc: {
    type: String,
    default: '/assets/images/chad.jpg'
  },
  imageEightAlt: {
    type: String,
    default: 'Chad Tackett'
  },
  buttonText: {
    type: String,
    default: 'Save 50% Now'
  }
})

defineBuilderComponent({
    friendlyName: "LifeBoostIncludes",
    canHaveChildren: true,
    inputs: [
        {
            name: "imageOneSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "svg",
                "png"
            ],
            required: true,
            defaultValue: "/assets/images/everyone.png"
        },
        {
            name: "imageOneAlt",
            type: "string",
            defaultValue: "lifeboost coffee including"
        },
        {
            name: "imageTwoSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "svg",
                "png"
            ],
            required: true,
            defaultValue: "/assets/images/charts.jpg"
        },
        {
            name: "imageTwoAlt",
            type: "string",
            defaultValue: "top-influencers"
        },
        {
            name: "imageThreeSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "svg",
                "png"
            ],
            required: true,
            defaultValue: "/assets/images/fb-results.jpg"
        },
        {
            name: "imageThreeAlt",
            type: "string",
            defaultValue: "lifeboost charts"
        },
        {
            name: "imageFourSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "svg",
                "png"
            ],
            required: true,
            defaultValue: "/assets/images/testimonials_01.jpg"
        },
        {
            name: "imageFourAlt",
            type: "string",
            defaultValue: "doctors love lifeboost"
        },
        {
            name: "imageFiveSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "svg",
                "png"
            ],
            required: true,
            defaultValue: "/assets/images/testimonials_02.jpg"
        },
        {
            name: "imageFiveAlt",
            type: "string",
            defaultValue: "health fitness professionals love lifeboost"
        },
        {
            name: "imageSixSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "svg",
                "png"
            ],
            required: true,
            defaultValue: "/assets/images/dan-long.jpg"
        },
        {
            name: "imageSixAlt",
            type: "string",
            defaultValue: "Dan Long"
        },
        {
            name: "imageSevenSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "svg",
                "png"
            ],
            required: true,
            defaultValue: "/assets/images/ed.jpg"
        },
        {
            name: "imageSevenAlt",
            type: "string",
            defaultValue: "Ed O'Keefe"
        },
        {
            name: "imageEightSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "svg",
                "png"
            ],
            required: true,
            defaultValue: "/assets/images/chad.jpg"
        },
        {
            name: "imageEightAlt",
            type: "string",
            defaultValue: "Chad Tackett"
        }
    ]
});
</script>